import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { CommonDialog } from "../../common/CommonDialog";
import { difficultyOptions } from "../../common/const";
import CatService from "../../../service/CatService";
import { attrFormField } from "../../cat/udf/AttrForm";
import { useTranslation } from "react-i18next";

export function SetProp({visible,onOK,onCancel})
{    
    const {t}=useTranslation();
    const [values,setValues]=useState({propType:null,difficulty:3,weight:1.0,descr:''});
    const [udfs,setUdfs]=useState([]);

    const propertyOptions=[
        {label:t('Difficulty'),value:'difficulty'},
        {label:t('Weight'),value:'weight'},
        {label:t('Description'),value:'descr'},
        {label:t('Usages'),value:'usages'}
    ]
    const onChange=(formData)=>{        
        setValues(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        const pt = values.propType;
        if(pt == undefined)
            onOK(null);
        const propValue = values[pt];
        onOK({propType:values.propType,propValue:propValue});
    };
    const retrieveUdfs=()=>{
        CatService.getUdfByEntity('Question').then((ret)=>{
            setUdfs(ret);
        });
    };
    const diffOptions=()=>{
        return difficultyOptions.map((d)=>{return {label:t('@difficulty.'+d.value),value:d.value}});
    }
    const fields=()=>{
        udfs.forEach((udf)=>{
            propertyOptions.push(udf.name);
        });
        var fields = [
            {id:"propType",ftype:"dropdown",field:"propType",label:t("Property"),options:propertyOptions},
            {id:"difficulty",ftype:"dropdown",field:"difficulty",label:t("Difficulty"),options:diffOptions(), hidden:values.propType!='difficulty'},                    
            {id:"weight",ftype:"number",field:"weight",label:t("Weight"),hidden:values.propType!='weight'},
            {id:"descr",ftype:"text",field:"descr",label:t("Description"),hidden:values.propType!='descr'},
            {id:"usages",ftype:"number",field:"usages",label:t("Usages"),hidden:values.propType!='usages'},

        ];
        udfs.forEach((udf)=>{
            if(udf != undefined)
            {
                var fld = attrFormField(udf);
                if(fld)
                {
                    fld.hidden = true;
                    if(values.propType != undefined && values.propType == fld.id)
                        fld.hidden = false;
                    fields.push(fld);    
                }
            }
        });
        return fields;
    }
    useEffect(()=>{
        retrieveUdfs();
    },[]);
    return(
        <>
        <CommonDialog header={t("Set property")} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{width:'400px',height:'200px'}}>
            <Form id="setProp" formData={values} columns="1" onChange={onChange}
                fields={fields()}>
            </Form>	
            </div>
        </CommonDialog>
        </>
    );
}